import React from 'react';
import { useIntl } from 'react-intl-next';
import { listMessages } from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import ListNumberedIcon from '@atlaskit/icon/core/list-numbered';
var NumberedListBlockMenuItem = function NumberedListBlockMenuItem(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var orderedListActive = useSharedPluginStateSelector(api, 'list.orderedListActive');
  var currentSelectedNodeName = useSharedPluginStateSelector(api, 'blockMenu.currentSelectedNodeName');

  // Check if a blockquote is currently selected
  var isBlockquoteSelected = currentSelectedNodeName === null || currentSelectedNodeName === void 0 ? void 0 : currentSelectedNodeName.includes('blockquote');

  // Only show as selected if ordered list is active AND we're not selecting a blockquote
  var isSelected = orderedListActive && !isBlockquoteSelected;
  var handleClick = function handleClick() {
    if (!orderedListActive) {
      var _api$blockMenu;
      api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.formatNode("orderedList"));
    }
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    onClick: handleClick,
    isSelected: isSelected,
    elemBefore: /*#__PURE__*/React.createElement(ListNumberedIcon, {
      label: ""
    })
  }, formatMessage(listMessages.orderedList));
};
export var createNumberedListBlockMenuItem = function createNumberedListBlockMenuItem(_ref2) {
  var api = _ref2.api;
  return function () {
    return /*#__PURE__*/React.createElement(NumberedListBlockMenuItem, {
      api: api
    });
  };
};